import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

// 云采购的供应商管理路由引入
import supplierManageRoutes from '@/router/business/supplier-manage/index'

export default {
  path: 'supplier-manage',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '供应商管理',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.PURCHASER.right,
    platformFunctionModuleDict.FRAMEWORK_AGREEMENT.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: supplierManageRoutes.children.filter(
    route => !['框架协议'].includes(route.meta.title)
  )
}
